import React, { type ReactNode, type ReactPortal } from 'react';

import { createPortal } from 'react-dom';

import './Modal.scss';

interface Props {
    isShowing: boolean;
    hide: () => void;
    children: ReactNode;
    isLarge?: boolean;
    hideClose?: boolean;
    fit?: boolean;
}

export const ModalElement = ({
    isShowing,
    hide,
    children,
    isLarge = false,
    hideClose = false,
    fit = false,
}: Props): ReactPortal | null =>
    isShowing
        ? createPortal(
              <React.Fragment>
                  <div className="modal-overlay" />
                  <div className="modal-wrapper" aria-modal aria-hidden tabIndex={-1} role="dialog">
                      <div className={`modal ${isLarge ? 'large' : ''} ${fit ? 'fit' : ''}`}>
                          {!hideClose && (
                              <div className="modal-header">
                                  <button
                                      type="button"
                                      className="modal-close-button"
                                      data-dismiss="modal"
                                      aria-label="Close"
                                      onClick={hide}
                                  >
                                      <span aria-hidden="true">&times;</span>
                                  </button>
                              </div>
                          )}
                          {children}
                      </div>
                  </div>
              </React.Fragment>,
              document.body,
          )
        : null;
